import React from "react";
import { ReactComponent as Sun } from "./Sun.svg";
import { ReactComponent as Moon } from "./Moon.svg";
import "./DarkMode.css";

const DarkMode = () => {

    const setBlueMode = () => {
        document.querySelector("body").setAttribute('color-theme', 'blue');
        localStorage.setItem("selectedTheme", "blue");
    };

    const setMode = value => {
        document.querySelector("body").setAttribute('color-theme', value);
        localStorage.setItem("selectedTheme", value);
        // localStorage.getItem("selectedTheme");
    };

    const toggleTheme = (e, value) => {
        console.log(value);
        if (e.target.checked) {
            setMode(value)
        }
        else setBlueMode();
    }

    const selectedTheme = localStorage.getItem("selectedTheme");
    if (selectedTheme) {
        setMode(
            localStorage.getItem("selectedTheme")
        );

    }

    return (

        <div className="themeDiv">

            <a href="#" className="float btn-primary">

                <i className="fa fa-palette icon"></i>
            </a>
            <ul>
                <li>
                    <label className="gray-bg">
                        <input type="radio" name="themecheck" value="gray"
                            onChange={(e) => toggleTheme(e, "gray")}
                        />
                        <i className="fa fa-fill-drip"></i>
                    </label>
                </li>
                <li>
                    <label className="red-bg">
                        <input type="radio" name="themecheck" value="red"
                            onChange={(e) => toggleTheme(e, "red")}
                        />
                        <i className="fa fa-fill-drip"></i>
                    </label>
                </li>
                <li>
                    <label className="green-bg">
                        <input type="radio" name="themecheck" value="green"
                            onChange={(e) => toggleTheme(e, "green")}
                        />
                        <i className="fa fa-fill-drip"></i>
                    </label>
                </li>
                <li>
                    <label className="orange-bg">
                        <input type="radio" name="themecheck" value="orange"
                            onChange={(e) => toggleTheme(e, "orange")}
                        />
                        <i className="fa fa-fill-drip"></i>
                    </label>
                </li>
                <li>
                    <label className="blue-bg">
                        <input type="radio" name="themecheck" value="blue"
                            onChange={(e) => toggleTheme(e, "blue")}
                        />
                        <i className="fa fa-fill-drip"></i>
                    </label>
                </li>
            </ul>

        </div>

    );
};

export default DarkMode;
